<template>
  <div class="alert-container">
    <transition-group name="alert" tag="div">
      <div
        v-for="(alert, i) in alertArray"
        :key="alert.id || i"
        class="modern-alert"
        :class="`alert-${getAlertType(alert.color)}`">
        <div class="alert-content">
          <div class="alert-icon">
            <v-icon :color="getIconColor(alert.color)" size="20">
              {{ getAlertIcon(alert.color) }}
            </v-icon>
          </div>
          <div class="alert-message">
            {{ alert.text }}
          </div>
          <button 
            v-if="!isMobile"
            @click="dismissAlert(i)"
            class="alert-dismiss">
            <v-icon size="16" color="#6b7280">mdi-close</v-icon>
          </button>
        </div>
      </div>
    </transition-group>
    
    <transition-group name="alert" tag="div">
      <div
        v-for="(alert, i) in alert_list"
        :key="`legacy-${alert.id || i}`"
        class="modern-alert"
        :class="`alert-${getAlertType(alert.color)}`">
        <div class="alert-content">
          <div class="alert-icon">
            <v-icon :color="getIconColor(alert.color)" size="20">
              {{ getAlertIcon(alert.color) }}
            </v-icon>
          </div>
          <div class="alert-message">
            {{ alert.text }}
          </div>
          <button 
            @click="dismissLegacyAlert(i)"
            class="alert-dismiss">
            <v-icon size="16" color="#6b7280">mdi-close</v-icon>
          </button>
        </div>
      </div>
    </transition-group>
  </div>
</template>
<script>
export default {
  props: ['alertArray'],
  data() {
    return {
      alert_list: [],
      isMobile: this.$vuetify.breakpoint.width < 420,
    };
  },
  methods: {
    change_alert() {},
    raise_alert(alert) {
      this.alert_list = [];
      this.alert_list.push(alert);
      setTimeout(() => (this.alert_list = []), 1000 * 3);
    },
    dismiss_alert() {
      this.alert = false;
    },
    dismissAlert(index) {
      this.$emit('dismiss-alert', index);
    },
    dismissLegacyAlert(index) {
      this.alert_list.splice(index, 1);
    },
    getAlertType(color) {
      const typeMap = {
        'success': 'success',
        'info': 'info',
        'warning': 'warning',
        'error': 'error',
        'danger': 'error',
      };
      return typeMap[color] || 'info';
    },
    getAlertIcon(color) {
      const iconMap = {
        'success': 'mdi-check-circle',
        'info': 'mdi-information',
        'warning': 'mdi-alert',
        'error': 'mdi-alert-circle',
        'danger': 'mdi-alert-circle',
      };
      return iconMap[color] || 'mdi-information';
    },
    getIconColor(color) {
      const colorMap = {
        'success': '#10b981',
        'info': '#3b82f6',
        'warning': '#f59e0b',
        'error': '#ef4444',
        'danger': '#ef4444',
      };
      return colorMap[color] || '#3b82f6';
    },
  },
  mounted() {},
  // Leaving this as an example of another way to update the alerts.
  // May need this in the future and it'll save time having it here.

  // updated() {
  //   setTimeout(() => {
  //     this.alertArray.shift();
  //   }, 5000);
  // },
};
</script>
<style lang="scss" scoped>
@import '@/scss/variables.scss';

// Component-specific colors
$alert-success-bg-color: #f0fdf4;
$alert-success-border-color: #bbf7d0;
$alert-success-text-color: #166534;

$alert-info-bg-color: #eff6ff;
$alert-info-border-color: #bfdbfe;
$alert-info-text-color: #1e40af;

$alert-warning-bg-color: #fffbeb;
$alert-warning-border-color: #fed7aa;
$alert-warning-text-color: #92400e;

$alert-error-bg-color: #fef2f2;
$alert-error-border-color: #fecaca;
$alert-error-text-color: #dc2626;

$alert-dismiss-hover-bg-color: rgba(107, 114, 128, 0.1);

.alert-container {
  position: fixed;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 500px;
  width: 90%;
  
  @media (max-width: $breakpoint-mobile) {
    top: 90px;
    width: calc(100% - 32px);
    max-width: none;
  }
}

.modern-alert {
  border-radius: 8px;
  box-shadow: $shadow-md;
  border: 1px solid;
  transform: translateX(0);
  
  &.alert-success {
    background-color: $alert-success-bg-color;
    border-color: $alert-success-border-color;
    
    .alert-message {
      color: $alert-success-text-color;
    }
  }
  
  &.alert-info {
    background-color: $alert-info-bg-color;
    border-color: $alert-info-border-color;
    
    .alert-message {
      color: $alert-info-text-color;
    }
  }
  
  &.alert-warning {
    background-color: $alert-warning-bg-color;
    border-color: $alert-warning-border-color;
    
    .alert-message {
      color: $alert-warning-text-color;
    }
  }
  
  &.alert-error {
    background-color: $alert-error-bg-color;
    border-color: $alert-error-border-color;
    
    .alert-message {
      color: $alert-error-text-color;
    }
  }
}

.alert-content {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 12px;
  
  @media (max-width: $breakpoint-mobile) {
    padding: 14px;
    gap: 10px;
  }
}

.alert-icon {
  flex-shrink: 0;
}

.alert-message {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  
  @media (max-width: $breakpoint-mobile) {
    font-size: 13px;
  }
}

.alert-dismiss {
  flex-shrink: 0;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color $transition-fast $easing-smooth;
  margin-top: -2px;
  
  &:hover {
    background-color: $alert-dismiss-hover-bg-color;
  }
  
  &:focus {
    outline: none;
    background-color: $alert-dismiss-hover-bg-color;
  }
}

.alert-enter-active {
  transition: all $transition-normal $easing-smooth;
}

.alert-leave-active {
  transition: all $transition-fast $easing-smooth;
}

.alert-enter-from {
  opacity: 0;
  transform: translateY(-20px) scale(0.95);
}

.alert-leave-to {
  opacity: 0;
  transform: translateY(-10px) scale(0.98);
}

.alert-move {
  transition: transform $transition-normal $easing-smooth;
}
</style>
